<div class="modal-header bg-soft-info p-3">
    <h5 class="modal-title" id="exampleModalLabel" i18n="@@">
        <span *ngIf="documentName else elseNoDocumentName">{{documentName}}</span>
        <ng-template #elseNoDocumentName>
            <span>Document View</span>
        </ng-template>
    </h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
        (click)="close()"></button>
</div>
<div class="card-body">
    <ngx-extended-pdf-viewer *ngIf="pdfSrc" style="text-align: center; width: {{widthPx}}px;" [useBrowserLocale]="true"
        [zoom]="'page-width'" [theme]="'dark'" [height]="'auto'" [showDrawEditor]="false" [showTextEditor]="false"
        [textLayer]="true" [showStampEditor]="false" [src]="pdfSrc" [showOpenFileButton]="false"
        [showHandToolButton]="true" [handTool]="false" [showSecondaryToolbarButton]="false">
    </ngx-extended-pdf-viewer>
    <div *ngIf="showNoDocument">
        <div class="text-center" style="text-align: center; width: {{widthPx}}px; border: 1px solid black;">
            <h4 class="text-danger" style="padding-top: 0.5rem;"> Document Failed to Load</h4>
        </div>
    </div>
</div>